module.exports = __webpack_public_path__ + "static/media/Style-Clubs-Serif-Italic.778284be.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Style-Clubs-Serif-Italic.eot
// module id = 2976
// module chunks = 68